<template>
	<b-modal
		ref="specimen-weight-detail-modal"
		size="xmd"
		:title="title"
		hide-footer
		@hidden="$emit('close')"
		scrollable
	>
		<b-overlay :show="isLoading">
			<b-row class="mb-1">
				<b-col class="d-flex align-items-center">
					<small class="text-secondary">
						Mostrando {{ pagination.from }} a {{ pagination.to }} de {{ pagination.total }} registros
					</small>
				</b-col>
				<b-col class="d-flex align-items-center justify-content-end flex-wrap gap-x-4 gap-y-1">
					<b-pagination
						v-model="pagination.curPage"
						:total-rows="pagination.total"
						:per-page="pagination.perPage"
						first-number
						last-number
						class="mb-0 mt-1 mt-sm-0"
						prev-class="prev-item"
						next-class="next-item"
					>
						<template #prev-text>
							<feather-icon icon="ChevronLeftIcon" size="18" />
						</template>
						<template #next-text>
							<feather-icon icon="ChevronRightIcon" size="18" />
						</template>
					</b-pagination>
				</b-col>
			</b-row>
			<b-row class="mb-1">
				<b-col cols="12" xl="7" class="d-flex align-items-center justify-content-start mt-1 mb-md-0">
					<label>Mostrar</label>
					<v-select
						v-model="pagination.perPage"
						:options="perPageOptions"
						:clearable="false"
						class="per-page-selector d-inline-block mx-50"
						style="width: 90px"
					/>
					<label class="mr-2">registros</label>
					<feather-icon class="cursor-pointer" icon="RefreshCcwIcon" size="20" @click="refresh" />
				</b-col>
				<b-col cols="12" xl="5">
					<div class="container-btns-page-specimens">
						<div class="d-flex">
							<b-input-group id="cintillo-ala-input-group">
								<b-form-input
									v-model="search"
									class="d-inline-block"
									placeholder="Por placa o alias"
									@keyup.enter="handleInputSearch"
									debounce="500"
								/>
								<b-input-group-append>
									<b-button variant="outline-primary" @click="handleInputSearch()">
										<feather-icon class="cursor-pointer" icon="SearchIcon" />
									</b-button>
								</b-input-group-append>
							</b-input-group>
						</div>
					</div>
				</b-col>
			</b-row>
			<b-table-simple responsive sticky-header="60vh" no-border-collapse>
				<b-thead class="sticky-header" style="white-space: nowrap">
					<b-tr>
						<b-th v-for="field in fields" :key="field.key" :class="field.class">{{ field.label }}</b-th>
					</b-tr>
				</b-thead>
				<b-tbody>
					<template v-if="specimens.length > 0">
						<b-tr v-for="(specimen, index) in specimens" :key="index">
							<b-td class="text-center">
								<SpecimenPlate :specimen="specimen" show_status />
							</b-td>
							<b-td class="text-center">
								<span>{{ specimen.kg_weight }}</span>
							</b-td>
							<b-td class="text-center">
								<span>{{ specimen.pounds_weight }}</span>
							</b-td>
						</b-tr>
					</template>
					<b-tr v-if="specimens.length === 0">
						<b-td :colspan="fields.length" class="text-center">No hay registros para mostrar</b-td>
					</b-tr>
				</b-tbody>
			</b-table-simple>
		</b-overlay>
	</b-modal>
</template>

<script>
import specimensService from "@/services/specimens.service"
import SpecimenPlate from "@/components/specimens/SpecimenPlate.vue"

export default {
	components: { SpecimenPlate },
	props: {
		categoryId: {
			type: Number,
			required: true,
		},
		year: {
			type: Number,
			required: true,
		},
		month: {
			type: Number,
			required: true,
		},
	},
	data: () => ({
		months: {
			1: "Enero",
			2: "Febrero",
			3: "Marzo",
			4: "Abril",
			5: "Mayo",
			6: "Junio",
			7: "Julio",
			8: "Agosto",
			9: "Septiembre",
			10: "Octubre",
			11: "Noviembre",
			12: "Diciembre",
		},
		categories: {
			1: "Padrillos",
			2: "Madrillas",
			3: "Gallos",
			4: "Gallinas",
			5: "Pollones",
			6: "Pollas",
		},
		search: "",
		isLoading: false,
		fields: [
			{ key: "specimen", label: "Ejemplar", class: "text-center" },
			{ key: "kg_weight", label: "Peso(Kg)", class: "text-center" },
			{ key: "pounds_weight", label: "Peso(Lb)", class: "text-center" },
		],
		perPageOptions: [10, 25, 50],
		pagination: {
			total: 0,
			curPage: 1,
			perPage: 25,
			from: 0,
			to: 0,
		},
		specimens: [],
	}),
	computed: {
		title() {
			return `Pesos de ${this.months[this.month]} ${this.year} | ${this.categories[this.categoryId]}`
		},
	},
	methods: {
		refresh() {
			this.getRows()
		},
		handleInputSearch() {
			this.getRows()
		},
		async getRows(page = 1) {
			try {
				this.isLoading = true
				const { data } = await specimensService.getAverageWeightsReportSpecimens({
					per_page: this.pagination.perPage,
					page: page,
					category_id: this.categoryId,
					year: this.year,
					month: this.month,
					search: this.search,
				})
				this.specimens = data.data || []
				this.pagination.curPage = data.current_page
				this.pagination.total = data.total
				this.pagination.from = data.from
				this.pagination.to = data.to
			} catch (error) {
				console.error("Error fetching average weights report specimens:", error)
			} finally {
				this.isLoading = false
			}
		},
	},
	watch: {
		"pagination.curPage": async function () {
			await this.getRows(this.pagination.curPage)
		},
		"pagination.perPage": async function () {
			await this.getRows()
		},
	},
	async mounted() {
		await this.getRows()
		this.$refs["specimen-weight-detail-modal"].toggle()
	},
}
</script>
